import $ from 'jquery';
import debug from 'debug';
import plugin from '@core/plugins/lib';

const ELEMENT_SELECTOR = '[data-header-controller]';
const PLUGIN_NAME = 'headerController';

const log = debug('site-header/header-controller:header');

class HeaderController {
	constructor(element, options) {
		log('element', element);
		log('options', options);

		this.options = options;
		this.element = element;
		this.$element = $(element);

		this.collapsibles = [...this.element.querySelectorAll(this.options.collapsibleSelector)];
		this.overlay = document.querySelector(this.options.overlaySelector);

		this.watch();

		log('ready', this, this.$target);
	}

	watch() {
		log('watching');

		this.element.addEventListener('collapsibleOpened', this.handleOpening.bind(this));
		this.element.addEventListener('collapsibleClosed', this.handleClosing.bind(this));

		if(this.overlay) {
			this.overlay.addEventListener('click', this.closeAllCollapsibles.bind(this));
		}
	}

	closeAllCollapsibles(){
		this.collapsibles.forEach((item) => {
			const collapseStateAttr = item.dataset['headerController-Collapsible'];
			item.dataset[collapseStateAttr] = false;
		});
		this.hideOverlay();
	}

	closeOtherCollapsibles(opener){
		const toCollapse = this.collapsibles.filter(function(item) {
			return item !== opener;
		});

		toCollapse.forEach((item) => {
			const collapseStateAttr = item.dataset['headerController-Collapsible'];
			item.dataset[collapseStateAttr] = false;
		});
	}

	handleOpening(event){
		const opener = event.target;
		this.closeOtherCollapsibles(opener);
		this.displayOverlay();
	}

	// Presumes the closing event is called only when the collapsible closes itself
	//	Not when it is closed externally
	handleClosing(event){
		this.hideOverlay();
	}

	displayOverlay(){
		if(this.overlay) {
			this.overlay.hidden = false;
		}
	}

	hideOverlay(){
		if(this.overlay) {
			this.overlay.hidden = true;
		}
	}


}

HeaderController.DEFAULTS = {};

plugin(PLUGIN_NAME, HeaderController);

$(document).ready(() => {
	$(ELEMENT_SELECTOR)[PLUGIN_NAME]();
});




// WEBPACK FOOTER //
// ./project/client/src/core/components/site-header/site-header-controller.js